var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1778BE",
    fillRule: "evenodd",
    d: "M11 2a1 1 0 0 1 1 1v1h5a1 1 0 1 1 0 2h-5v1a1 1 0 1 1-2 0V6H8a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h7a1 1 0 1 1 0 2H8a6 6 0 0 1-6-6V10a6 6 0 0 1 6-6h2V3a1 1 0 0 1 1-1zm10 0a1 1 0 0 1 1 1v1h2a6 6 0 0 1 6 6v5a1 1 0 1 1-2 0v-5a4 4 0 0 0-4-4h-2v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1zM8 11a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2zm18.879 10c-.298 0-.583.118-.793.328L21 26.414V28h1.586l5.086-5.086A1.121 1.121 0 0 0 26.879 21zm-2.207-1.086a3.121 3.121 0 0 1 4.414 4.414l-5.379 5.38A1 1 0 0 1 23 30h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 .293-.707zM10 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.14a95aa07e76afcb45c0c47105dc4927.svg";
export { ForwardRef as ReactComponent };